import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './styles';

const StatusLegend = ({ classes }) => {
  const { t: translate } = useTranslation();
  const items = [
    { label: translate('common:InOperation'), type: 'operation' },
    { label: translate('common:CodeOperationalStopType'), type: 'operationStop' },
    { label: translate('common:Maintenance'), type: 'maintenance' },
    { label: translate('common:Inactive'), type: 'empty' },
  ];

  return (
    <div className={classes.container}>
      {items.map(item => (
        <div key={item.label} className={classes.item}>
          <div className={classNames(classes.dot, classes[item.type])} />
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(StatusLegend);
